{
  "version": 1,
  "asset_id": "307f23c8-543c-403a-8960-22807a57b986",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/307f23c8-543c-403a-8960-22807a57b986/lecanto-metal-roof-after-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/307f23c8-543c-403a-8960-22807a57b986/lecanto-metal-roof-after-480w.avif",
  "original_filename": "lecanto-metal-roof-after-480w.avif",
  "size": 19956,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
